/* global moment */
var ctrlopt = ctrlopt;

(function ($) {
  var apptBook = Drupal.appointmentBooking;
  var settings = Drupal.settings.globals_variables || {};
  var oab_date_time_override = settings.oab_date_time_override || 0;
  var oab_date_override = settings.oab_override_date_format ? settings.oab_override_date_format : 0;
  var oab_time_override = settings.oab_override_time_format ? settings.oab_override_time_format : 0;
  var oab_russian_date_format = settings.oab_russian_date_format ? settings.oab_russian_date_format : 0;
  var allow_priced_services = settings.allow_priced_services ? settings.allow_priced_services : 0;
  var OAB_price_override = settings.OAB_override_price_format ? settings.OAB_override_price_format : 0;
  var currencySymbol = settings.OAB_price_currency ? settings.OAB_price_currency : '$';
  var oab_year_first = settings.oab_year_first || 0;
  var oab_year_suffix = settings.oab_year_suffix ? settings.oab_year_suffix : '';
  var oab_month_suffix = settings.oab_month_suffix ? settings.oab_month_suffix : '';
  var oab_day_suffix = settings.oab_day_suffix ? settings.oab_day_suffix : '';
  var oab_date_time_dayname_day_month = settings.oab_date_time_dayname_day_month || 0;

  /* Concrete View */
  apptBook.ConfirmSection = function (container) {
    apptBook.ConfirmSection.superclass.constructor.call(this);
    this.id = 'confirmation';
    this.container = container;
    this.confContainer = container.find('.confirmation-container');
    this.lessons = this.confContainer.find('.your-lessons');
    this.lesson = this.lessons.find('.lesson').remove();
    this.location = this.confContainer.find('.location');
    this.dateTime = this.confContainer.find('.date-time');
    this.artistName = this.confContainer.find('.artist');
    this.minLabel = this.container.attr('data-minutes-label');
    this.months = this.container.attr('data-month-names').split(',');
    this.yearSuffix = this.container.attr('data-year-suffix');
    this.daySuffix = this.container.attr('data-day-suffix');
    this.monthSuffix = this.container.attr('data-month-suffix');
    this.amSuffix = this.container.attr('data-am-suffix');
    this.pmSuffix = this.container.attr('data-pm-suffix');
    this.confirmationDateFormat = this.container.attr('data-confirmation-date-format');
    this.totalDuration = 0;
    this.totalPrice = 0;
    this.isVirtual = 0;
  };

  ctrlopt.extend(apptBook.ConfirmSection, apptBook.AbstractSection);

  apptBook.ConfirmSection.prototype.onUpdate = function (data) {
    var me = this;

    if (data.sectionId === this.id) {
      this.confData = data.params;
      if (data.params.counter.calendars[0].virtual === '1') {
        this.isVirtual = 1;
      }
      this.buildLessons(this.confData.services);
      if (!this.isVirtual) {
        this.buildLocation(this.confData.counter);
      }
      this.buildDateTime(this.confData);
      this.buildArtistName(this.confData.calendar);
      if (this.isVirtual) {
        this.container.find('.virtual_oab_content').removeClass('hidden');
        // zoom link update in confirmation page
        var zoomLink = this.confData.virtual_meeting_link ? this.confData.virtual_meeting_link : '';
        var zoomContainer = this.container.find('#zoom-link');

        if (zoomLink) {
          zoomContainer.attr('href', zoomLink);
          zoomContainer.text(zoomLink);
        }
      } else {
        this.container.find('.physical_oab_content').removeClass('hidden');
      }
    }
  };

  apptBook.ConfirmSection.prototype.buildLessons = function (data) {
    var myData, myNode, myLName, myLTime, myLPrice, time,
      me = this;

    this.lessons.find('.lesson').remove();
    for (var i = 0, len = data.length; i < len; i += 1) {
      myData = data[i];
      myNode = this.lesson.clone();
      myLName = myData.name;
      myLTime = myData.total_duration;
      myLPrice = myData.price;
      me.totalDuration += parseInt(myLTime);
      me.totalPrice += parseInt(myLPrice);
      time = myLTime + ' ' + this.minLabel;

      if (parseInt(myLPrice) && allow_priced_services) {
        var price = OAB_price_override ? myLPrice + currencySymbol : currencySymbol + '\xA0' + myLPrice;

        myNode.html(myLName + ' (' + time + ' /' + price + ')');
      } else {
        myNode.html(myLName + ' (' + time + ')');
      }
      this.lessons.append(myNode);
    }
  };

  apptBook.ConfirmSection.prototype.buildLocation = function (data) {
    var tpStr = '',
      googleStr = '',
      name = data.name,
      addr1 = data.address1,
      addr2 = data.address2,
      town = data.town,
      county = data.county,
      postCode = data.postcode,
      phone = data.phone,
      email = data.email,
      nameNode = this.location.find('.location-name'),
      addrNode = this.location.find('.location-address'),
      addr2Node = this.location.find('.location-address2'),
      townPostNode = this.location.find('.location-town-postcode'),
      phoneNode = this.location.find('.location-phone'),
      getDir = this.location.find('.location-direction-links');

    if (name) {
      nameNode.html(name);
      googleStr += name;
    } else {
      nameNode.hide();
    }

    if (addr1) {
      addrNode.html(addr1);
      googleStr += '+' + addr1;
    } else {
      addrNode.hide();
    }

    if (addr2) {
      addr2Node.html(addr2);
      googleStr += '+' + addr2;
    } else {
      addr2Node.hide();
    }

    if (town) {
      tpStr += town;
      googleStr += '+' + town;
    }

    if (postCode) {
      if (county) {
        tpStr += tpStr === '' ? postCode : ', ' + county + ' ' + postCode;
      } else {
        tpStr += tpStr === '' ? postCode : ', ' + postCode;
      }
      googleStr += '+' + postCode;
    }

    if (tpStr === '') {
      townPostNode.hide();
    } else {
      townPostNode.html(tpStr);
    }

    if (phone) {
      phoneNode.html(phone);
      phoneNode.attr('href', 'tel:' + phone);
    } else {
      phoneNode.hide();
    }

    getDir.attr('href', 'https://www.google.com/maps?daddr=' + encodeURIComponent(googleStr));
  };

  apptBook.ConfirmSection.prototype.buildDateTime = function (data) {
    var m, d, y, h, hSuffix, apptTimeStr,
      apptDate = this.convertTimeString(data.start_time),
      apptEndDate = new Date(apptDate.getTime()),
      dateNode = this.dateTime.find('.appt-date'),
      atCopy = dateNode.text(),
      me = this,
      hSuffix_jp,
      apptHours,
      apptminutes,
      oab_moment_js_override_meridiem = settings.oab_moment_js_override_meridiem || 0,
      oab_moment_js_local = settings.oab_moment_js_local || '',
      oab_moment_js_meridiem_am = settings.oab_moment_js_meridiem_am || 'AM',
      oab_moment_js_meridiem_pm = settings.oab_moment_js_meridiem_pm || 'PM';

    me.calContainer = me.container.find('.appt-date-cal');
    me.addCalLink = me.calContainer.find('.add-cal-link');
    me.calLinksCont = me.calContainer.find('.cals-container');
    me.calLinks = me.calContainer.find('.date-time-link');

    if (me.calContainer.length) {
      var addCalLink = me.calContainer.find('.add-cal-link'),
        calLinks = me.calContainer.find('.date-time-link'),
        addCalTitle = me.calContainer.find('.add-cal-title').html() || 'Clinique Appointment',
        addCalDesc = me.calContainer.find('.add-cal-desc').html() || "Your Makeup Appointment is booked! Please arrive ten minutes before your lesson. We're looking forward to seeing you in person.",
        addr1 = data.counter.address1 || '',
        addr2 = data.counter.address2 || '',
        town = data.counter.town || '',
        postcode = data.counter.postcode || '';
    }
    apptEndDate.setTime(apptEndDate.getTime() + parseInt(me.totalDuration) * 60000);
    dateNode.empty();
    // Uses a moment date/time formatting string from CMS
    if (this.confirmationDateFormat) {
      if (oab_moment_js_override_meridiem && oab_moment_js_local) {
        var currentLocale = moment.locale();

        moment.defineLocale(oab_moment_js_local, {
          meridiem: function (hours) {
            if (hours > 11) {
              return oab_moment_js_meridiem_pm;
            }

            return oab_moment_js_meridiem_am;
          }
        });
        moment.locale(currentLocale); // We don't want to change the locale from what it was previously :)
      }
      apptTimeStr = moment(apptDate).format(this.confirmationDateFormat);
    } else { // Else if no moment string set use this complicated logic. Moving forward, NO NEW SITES should use this.
      var month = apptDate.getMonth() + 1;

      m = oab_russian_date_format ? month < 10 ? '0' + month : month : this.months[apptDate.getMonth()];
      d = apptDate.getDate();
      y = apptDate.getFullYear();
      h = apptDate.getHours();
      var min = apptDate.getMinutes();

      hSuffix = h < 12 ? 'AM' : 'PM';

      if (oab_date_time_override) {
        hSuffix_jp = apptDate.getHours() < 12 ? this.amSuffix : this.pmSuffix;
        apptHours = apptDate.getHours() % 12;
        apptHours = apptHours ? apptHours : 12;
        apptHours = apptHours < 10 ? apptHours : apptHours;
        apptminutes = apptDate.getMinutes() < 10 ? '0' + apptDate.getMinutes() : apptDate.getMinutes();
      }

      if (oab_time_override) {
        h = h + ':' + (min === 0 ? '00' : min);
      } else {
        h = ((h + 11) % 12 + 1) + (min !== 0 ? ':' + min + hSuffix : hSuffix);
      }

      if (oab_russian_date_format) {
        apptTimeStr = d + '.' + m + '.' + y + ' ' + atCopy + ' ' + h;
      } else if (oab_date_override) {
        apptTimeStr = d + ' ' + m + ' ' + y + ' ' + atCopy + ' ' + h;
      } else if (oab_date_time_override) {
        apptTimeStr = y + this.yearSuffix + ('0' + (apptDate.getMonth() + 1)).slice(-2) + this.monthSuffix + d + this.daySuffix + ' ' + apptHours + ':' + apptminutes + hSuffix_jp;
      } else if (oab_year_first) {
        apptTimeStr = y + oab_year_suffix + ' ' + m + oab_month_suffix + ' ' + d + oab_day_suffix + ' ' + h;
      } else if (oab_date_time_dayname_day_month) {
        apptTimeStr = d + ' ' + m + ' ' + y + ' ' + atCopy + ' ' + h;
      } else {
        apptTimeStr = m + ' ' + d + ', ' + y + ' ' + atCopy + ' ' + h;
      }
    }

    // get zoom link
    virtCalLocation = data.virtual_meeting_link ? data.virtual_meeting_link : '';
    // adding zoom link in calender
    if (this.isVirtual && virtCalLocation) {
      addr1 = virtCalLocation;
      addressLink = addr1;
    } else {
      addressLink = addr1 + ', ' + town + ', ' + postcode;
    }

    dateNode.text(apptTimeStr);
    if (me.calContainer.length) {
      me.myCalendar = createCalendar({
        data: {
          device_mobile: site.client.isMobile,
          title: addCalTitle, // Event title
          start: new Date(apptDate.getTime()), // Event start date
          duration: me.totalDuration, // Event duration (IN MINUTES)
          end: new Date(apptEndDate.getTime()), // You can also choose to set an end time.
          address: addressLink,
          description: addCalDesc
        }
      });

      me.calLinks.each(function () {
        var $this = $(this);
        var calID = $(this).attr('data-cal');
        var data = $.grep(me.myCalendar, function (el, i) {
          if (el.calId.toLowerCase() === calID) {
            return el.calHref;
          }
        });
        var dataUri = data[0].calHref;

        createDownloadLink($this, dataUri, calID, 'calendar.ics');
        $this.on('click', function () {
          me.calLinksCont.toggleClass('expanded');
        });

        function createDownloadLink(anchorSelector, dataUri, calID, fileName) {
          var dateUriIE = '';
          var blobObject = null;

          if (window.navigator.msSaveOrOpenBlob && calID !== 'google') {
            dateUriIE = dataUri.split(',')[1];
            dateUriIE = decodeURIComponent(dateUriIE);
            var fileData = [dateUriIE];

            blobObject = new Blob(fileData);
            $(anchorSelector).on('click', function(e) {
              e.preventDefault();
              window.navigator.msSaveOrOpenBlob(blobObject, fileName);
            });
          } else {
            $(anchorSelector).attr('href', dataUri);
          }
        }
      });
      me.addCalLink.on('click', function () {
        me.calLinksCont.toggleClass('expanded');
      });
    }
  };

  apptBook.ConfirmSection.prototype.buildArtistName = function (data) {
    var aName = data.public_name,
      aNameNode = this.artistName.find('.artist-name');

    aNameNode.html(aName);
  };

  apptBook.ConfirmSection.prototype.convertTimeString = function (tString) {
    var split, dateArray, timeArray, y, m, d, hr, min, sec;

    split = tString.split(' ');
    dateArray = split[0].split('-');
    timeArray = split[1].split(':');

    y = parseInt(dateArray[0], 10);
    m = parseInt(dateArray[1], 10) - 1;
    d = parseInt(dateArray[2], 10);
    hr = parseInt(timeArray[0], 10);
    min = parseInt(timeArray[1], 10);
    sec = parseInt(timeArray[2], 10);

    return new Date(y, m, d, hr, min, sec);
  };

  Drupal.behaviors.apptBookConfirm = {
    attach: function (context) {
      var view = new apptBook.ConfirmSection($('#confirmation'));

      view.setModel(apptBook.sectionModel).startObserving();
    }
  };
})(jQuery);
